import React from "react"
import { window, document, exists } from "browser-monads"
import { Link } from "gatsby"

import logo from "../../images/gatsby-icon.png"
import { MdMenu, MdClose } from "react-icons/md"

exists(window)

class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isNavbarShow: false,
      navbarCollapseStyle: ``,
      navbarCollapseIcon: <MdMenu />,
      currentScrollHeight: 0,
      navBackground: `rgba(255,255,255,0.5)`,
      isThereAHeroImage: this.props.isThereAHeroImage,
    }
  }

  componentDidMount() {
    window.onscroll = () => {
      if (window.scrollY >= 200) {
        this.setState({ navBackground: `rgba(255,255,255,1)` })
      } else {
        this.setState({ navBackground: `rgba(255,255,255,0.5)` })
      }
    }
  }

  handleNavbarCollapse = () => {
    if (this.state.isNavbarShow) {
      this.setState({
        isNavbarShow: false,
        navbarCollapseStyle: ``,
        navbarCollapseIcon: <MdMenu />,
        navBackground: `rgba(255,255,255,0.5)`,
      })
    } else {
      this.setState({
        isNavbarShow: true,
        navbarCollapseStyle: `show`,
        navbarCollapseIcon: <MdClose />,
        navBackground: `rgba(255,255,255,1)`,
      })
    }
  }
  render() {
    const { data } = this.props
    if (this.state.isThereAHeroImage === true) {
      return (
        <React.Fragment>
          <nav
            style={{ backgroundColor: this.state.navBackground }}
            className="shadow-sm navbar navbar-expand-lg fixed-top navbar-light"
          >
            <div className="container">
              <Link className="navbar-brand" to="/">
                Ricardo Sawir
              </Link>

              <button
                onClick={this.handleNavbarCollapse}
                className="navbar-toggler"
                type="button"
              >
                {this.state.navbarCollapseIcon}
              </button>
              <div
                className={`${this.state.navbarCollapseStyle} collapse navbar-collapse justify-content-end 
               `}
              >
                <ul className="navbar-nav align-items-end">
                  {data.map(link => {
                    return (
                      <li key={link.id} className="nav-item">
                        <Link
                          activeClassName="font-weight-bold"
                          className={`nav-link `}
                          to={link.link}
                        >
                          {link.name}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </nav>
        </React.Fragment>
      )
    } else if (
      this.state.isThereAHeroImage === null ||
      this.state.isThereAHeroImage === undefined
    ) {
      return (
        <React.Fragment>
          <nav
            style={{ backgroundColor: `rgba(255,255,255,1)` }}
            className="shadow-sm navbar navbar-expand-lg fixed-top navbar-light"
          >
            <div className="container">
              <Link className="navbar-brand" to="/">
                Ricardo Sawir
              </Link>

              <button
                onClick={this.handleNavbarCollapse}
                className="navbar-toggler"
                type="button"
              >
                {this.state.navbarCollapseIcon}
              </button>
              <div
                className={`${this.state.navbarCollapseStyle} collapse navbar-collapse justify-content-end 
               `}
              >
                <ul className="navbar-nav align-items-end">
                  {data.map(link => {
                    return (
                      <li key={link.id} className="nav-item">
                        <Link
                          activeClassName="font-weight-bold"
                          className={`nav-link `}
                          to={link.link}
                        >
                          {link.name}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </nav>
        </React.Fragment>
      )
    }
  }
}

export default Navbar
